import React, { useState } from "react";
import Logo from "../assets/images/logo.png";
import "@fontsource-variable/nunito";
import "../style/admin-ui.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const LoginAdmin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isError, setIsError] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const Login = async (e) => {
    e.preventDefault();
    if (email === "" || password === "") {
      setMessage("Please input your email and password.");
      setIsError(true);
    } else {
      setIsLoading(true);
      try {
        await axios.post("/loginAdmin", {
          email: email,
          password: password,
        });
        setIsLoading(false);
        navigate("/dashboardAdmin");
      } catch (error) {
        setMessage(error.response?.data?.msg || "Login failed. Please try again.");
        setIsError(true);
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="adm-auth">
      <div className="adm-auth-card">
        <img className="adm-auth-logo" src={Logo} alt="Cutting Edge Academy" />
        <h1 className="adm-auth-title">Admin Login</h1>
        <p className="adm-auth-subtitle">Sign in to manage Cutting Edge Academy.</p>

        {isError && (
          <div className="adm-auth-error" role="alert">
            <i className="bi bi-exclamation-circle"></i>
            {message}
          </div>
        )}

        <form onSubmit={Login} noValidate>
          <div className="mb-3">
            <label className="form-label" htmlFor="admin-email">Email address</label>
            <input
              id="admin-email"
              type="email"
              className="form-control"
              placeholder="example@gmail.com"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <label className="form-label" htmlFor="admin-password">Password</label>
            <div className="adm-auth-password">
              <input
                id="admin-password"
                type={showPassword ? "text" : "password"}
                className="form-control"
                placeholder="Your password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="adm-auth-eye"
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={() => setShowPassword((v) => !v)}
              >
                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
              </button>
            </div>
          </div>

          <button type="submit" className="adm-btn adm-btn--primary" style={{ width: "100%", height: "44px" }} disabled={isLoading}>
            {isLoading && <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>}
            {isLoading ? "Signing in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginAdmin;
